exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Section_Print{display:none}.logo_invoice{margin:0 0 10px;padding:10px;display:inline-block;float:right}.logo_invoice img{width:115px;margin:0 0 10px}.Powered{display:inline-block;margin:30px 0 10px;padding:10px}.Powered span{color:#123b52;font-weight:700}.print_separator{width:100%;display:inline-block;float:right;border-bottom:solid}.tableforprint tr td hr{margin:2px 0}.tableforprint tr td{border-top:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/assets/printstyle.css
// module id = 1623
// module chunks = 0